(ns com.theplantscape.plant-web.components.footer)

(defn footer-blocks [blocks]
  (into [:div.grid.grid-cols-2.gap-8.sm:gap-6.sm:grid-cols-3]
        (mapv (fn footer-block [{:keys [title children]}]
                [:div [:h2.mb-6.text-sm.font-semibold.text-gray-900.uppercase.dark:text-white title]
                 (into      [:ul.text-gray-500.dark:text-gray-400.font-medium]
                            (mapv (fn footer-link [{:keys [title link]}]
                                    [:li.mb-4 [:a.hover:underline {:href link} title]]) children))])
              blocks)))

(defn footer-copyright [{:keys [name link icon]}]
  [:<>
   [:hr.my-6.border-gray-200.sm:mx-auto.dark:border-gray-700.lg:my-8]
   [:div.sm:flex.sm:items-center.sm:justify-between
    [:span.text-sm.text-gray-500.sm:text-center.dark:text-gray-400 "© 2023 - 2024"
     [:a.hover:underline {:href link} name] ". All Rights Reserved."]]])

(defn footer-icons [icons]
  (into  [:div.flex.mt-4.space-x-5.sm:justify-center.sm:mt-0]
         (mapv (fn footer-icons [{:keys [title link icon]}]
                 [:a {:href link}
                  [icon]
                  [:span.sr-only title]]) icons)))

(defn footer [{:keys [brand link-blocks]}]
  [:footer.bg-white.dark:bg-gray-900
   [:div.mx-auto.w-full.max-w-screen-xl.p-4.py-6.lg:py-8
    [:div.md:flex.md:justify-between
     [:div.mb-6.md:mb-0
      [:a.flex.items-center {:href (-> brand :link)}
       [:img.h-8.mr-3 {:src (-> brand :logo) :alt (-> brand :name)}]
       [:span.self-center.text-2xl.font-semibold.whitespace-nowrap.dark:text-white (-> brand :name)]]]
     [footer-blocks link-blocks]]
    [footer-copyright brand]
    [footer-icons []]]])
